// removed by extract-text-webpack-plugin
module.exports = {"component":"_1dxriBfKHwO0BAom2j1KbQ","title":"_3HZxehuu0gEA1S0apoUWx8","content":"MvwoG2W06lo-w840Pz923","btn":"OkPv7wLTM_woVxZf-EI0d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleActionCard/SingleActionCard.css
// module id = 1464
// module chunks = 0